export default "__VITE_ASSET__GiZHW$0R__"